import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

export function useAdmin() {
  const [adminMode, setAdminMode] = useState(false);
  const [secretPrompt, setSecretPrompt] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setAdminMode(!!session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setAdminMode(!!session);
    });

    return () => subscription.unsubscribe();
  }, []);

  const requestAdmin = () => setSecretPrompt(true);

  const cancelAdmin = () => {
    setSecretPrompt(false);
    setEmail('');
    setPassword('');
    setError('');
  };

  const disableAdmin = async () => {
    await supabase.auth.signOut();
    cancelAdmin();
  };

  const submitSecret = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error: signInError } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (signInError) {
      setError(signInError.message);
      setPassword('');
      return false;
    }
    setSecretPrompt(false);
    setEmail('');
    setPassword('');
    return true;
  };

  const handleToggle = (checked) => {
    if (checked) requestAdmin();
    else disableAdmin();
  };

  return {
    adminMode,
    secretPrompt,
    email,
    setEmail,
    password,
    setPassword,
    error,
    loading,
    submitSecret,
    cancelAdmin,
    handleToggle,
    disableAdmin,
  };
}
